import { createContext } from "react";

const OutcomingOrderMultiselectSelectionContext = createContext();

export default OutcomingOrderMultiselectSelectionContext;
